import axios from "./axios"
import JSONbig from "json-bigint"
// 封装get请求
export function get(url, params = {},options={}) {
  return axios({
    method: "get",
    url,
    params,
    transformResponse: data => {
      return JSONbig.parse(data)
    },
    ...options
  })
}
// 封装post请求
export function post(url, data = {},options={}) {
  return axios({
    method: "post",
    url,
    data,
    ...options
  })
}